import { Component, inject, OnInit, ViewChild, ElementRef, Output, EventEmitter, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modal',
  standalone: true,
  imports: [CommonModule,ReactiveFormsModule],
  templateUrl: './modal.component.html',
  styleUrl: './modal.component.css'
})
export class ModalComponent implements OnInit{
  @ViewChild("content",{static: false}) content!: ElementRef;
  @ViewChild("content2",{static: true}) content2!: ElementRef;
  @ViewChild("confirmacion",{static: true}) fine!: ElementRef;
  @Output() saveModal = new EventEmitter<any>();
  @Input() titulo!: string;
  @Input() tipo_color!: string;
  @Input() letra_color!: string;
  @Input() mensaje!: string;
  private modalService = inject(NgbModal);
  private contentCargando: NgbModalRef | undefined;
  private confirmacion: NgbModalRef | undefined;

  ngOnInit(): void {

  }

  alerta() {
		//this.modalService.open(this.content, { centered: true });
		this.modalService.open(this.content, { size: 'sm'  });
	}

  confirma(){
    //this.modalService.open(this.fine, {size: 'sm'})
    this.confirmacion = this.modalService.open(this.fine, {
      size: 'sm',
      //centered: true,
      windowClass: 'modalClass',
      keyboard: false
    });
  }

  cargando() {
		//this.modalService.open(this.content, { centered: true });
    this.contentCargando = this.modalService.open(this.content2, {
      backdrop: 'static',
      centered: true,
      windowClass: 'modalClass',
      keyboard: false
    });
	}

  guardar(){
    if(this.confirmacion){
      this.confirmacion.close();
      this.confirmacion  = undefined;
      this.saveModal.emit();
    }
  }

  cerrar(){
    //Este es para cerrar todos los modales existentes
    //this.modalService.dismissAll(this.content2)
    //----Este es para cerrar uno en especifico
    if(this.contentCargando){
      this.contentCargando.close();
      this.contentCargando  = undefined;
    }
  }

}
